import { atom } from 'jotai';
import { HomeModel } from '../Models/HomeModel';
import apiClient from '../API/InkyAPI';
import Axios from 'axios';

//The store for the HomeModel
export const HomeAtomCache = atom(new HomeModel());
export const HomeAtomFetching = atom(false);
export const HomeAtom = atom((get) => {
    return get(HomeAtomCache);
}, async (get, set) => {
    if (get(HomeAtomFetching)) {
        return;
    }

    console.log('homess');
    const tokenSource = Axios.CancelToken.source();

    if (get(HomeAtomCache).entries.length > 0) {
        return get(HomeAtomCache);
    }
    set(HomeAtomFetching, true);
    return apiClient.getHome('web', tokenSource).then(res => {
        console.log('home fetching');
        if (res.status == 200) {
            set(HomeAtomCache, res.data);
        }
    })
        .catch(err => {
            console.error('Something went wrong with fetching Home', err);
        }).finally(() => {
            set(HomeAtomFetching, false);
        });
});
// When the HomeAtom is mounted, load Home-data.
// HomeAtom.onMount = (set) => {
// const tokensource = Axios.CancelToken.source();
// apiClient.getHome('web', tokensource).then(res => {
//     if (res.status == 200) {
//         set(res.data);
//     }
// })
//     .catch(err => {
//         console.error('Something went wrong with fetching Home', err);
//     });
// };


// WHEELS-STORE
export const HomeEntriesAtom = atom([]);
